/* eslint-disable @typescript-eslint/no-unused-vars */
import type { AxiosInstance } from 'axios';

import { TripActionsRepository } from '@src/services/api/trips/trip-actions/trip-actions.repository';
import { CheckInOutRequest } from '@src/types/api/requests/check-in-out-request';

export class TripActionsRepositoryMock implements TripActionsRepository {
  constructor(private readonly axiosInstance: AxiosInstance) {}

  changeTimes(tripId: string, checkInOutRequest: CheckInOutRequest): Promise<void> {
    return Promise.resolve();
  }

  checkoutReservation(tripId: string): Promise<void> {
    return Promise.resolve();
  }
}
